if (process.env.NODE_ENV === 'production') {
  module.exports = require('./text-button.production.js');
} else {
  module.exports = require('./text-button.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/text-button/dist/es/text-button.js
// module id = 276
// module chunks = 0